import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import FormSelect from '../shared/select';
import { Countries } from './Countries';
export const CountrySelect = ({ columns, height, label, labelFontSize, labelLineHeight, placeholder, handleChange, options, favorites = [], labelColor, isMultiple, selectedLabelColor, selectedOptionColor, value, values, isTelephone = false, name, required, touched, isInvalid, language, }) => {
    const [countryList, setCountryList] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState();
    const [selectedCountry, setSelectedCountry] = useState();
    useEffect(() => {
        if (options === null || options === void 0 ? void 0 : options.length) {
            setCountryList(reorderCountries(options, favorites));
        }
        else {
            let tempCountryList = [];
            switch (language.toUpperCase()) {
                case 'FR-FR':
                    tempCountryList = Countries.map((country) => {
                        var _a, _b;
                        return Object.assign(Object.assign({}, country), { label: isTelephone
                                ? (_a = country.code) !== null && _a !== void 0 ? _a : ''
                                : (_b = country.label.french) !== null && _b !== void 0 ? _b : country.label.english, isSelected: isMultiple
                                ? values === null || values === void 0 ? void 0 : values.includes(country.value)
                                : value === country.value });
                    });
                    break;
                case 'DE-DE':
                    tempCountryList = Countries.map((country) => {
                        var _a, _b;
                        return Object.assign(Object.assign({}, country), { label: isTelephone
                                ? (_a = country.code) !== null && _a !== void 0 ? _a : ''
                                : (_b = country.label.german) !== null && _b !== void 0 ? _b : country.label.english, isSelected: isMultiple
                                ? values === null || values === void 0 ? void 0 : values.includes(country.value)
                                : value === country.value });
                    });
                    break;
                case 'EN-GB':
                    tempCountryList = Countries.map((country) => {
                        var _a;
                        return Object.assign(Object.assign({}, country), { label: isTelephone ? (_a = country.code) !== null && _a !== void 0 ? _a : '' : country.label.english, isSelected: isMultiple
                                ? values === null || values === void 0 ? void 0 : values.includes(country.value)
                                : value === country.value });
                    });
                    break;
                case 'NL-NL':
                default:
                    tempCountryList = Countries.map((country) => {
                        var _a, _b;
                        return Object.assign(Object.assign({}, country), { label: isTelephone
                                ? (_a = country.code) !== null && _a !== void 0 ? _a : ''
                                : (_b = country.label.dutch) !== null && _b !== void 0 ? _b : country.label.english, isSelected: isMultiple
                                ? values === null || values === void 0 ? void 0 : values.includes(country.value)
                                : value === country.value });
                    });
                    break;
            }
            setCountryList(reorderCountries(tempCountryList, favorites));
        }
    }, [options, value, language, values, isTelephone]);
    useEffect(() => {
        if (isMultiple && countryList) {
            setSelectedCountries(countryList.filter((country) => { var _a; return (_a = values === null || values === void 0 ? void 0 : values.includes(country.value)) !== null && _a !== void 0 ? _a : values === null || values === void 0 ? void 0 : values.includes(country.label); }));
        }
        else if (!isMultiple && countryList) {
            setSelectedCountry(countryList.find((country) => country.value === value || country.label === value));
        }
    }, [value, values, countryList]);
    const reorderCountries = (countries, favorites) => {
        if (!favorites || favorites.length === 0)
            return countries;
        const favCountries = [];
        const restCountries = [];
        countries.forEach((country) => {
            if (favorites.includes(country.value)) {
                favCountries.push(country);
            }
            else {
                restCountries.push(country);
            }
        });
        return [...favCountries, ...restCountries];
    };
    return (_jsx(FormSelect, { isClearable: true, name: name, required: required, columns: columns, height: height !== null && height !== void 0 ? height : 60, options: countryList.map((country) => {
            var _a;
            return (Object.assign(Object.assign({}, country), { label: isTelephone ? (_a = country.code) !== null && _a !== void 0 ? _a : '' : country.label }));
        }), label: label, labelFontSize: labelFontSize !== null && labelFontSize !== void 0 ? labelFontSize : undefined, labelLineHeight: labelLineHeight !== null && labelLineHeight !== void 0 ? labelLineHeight : undefined, placeholder: placeholder, handleChange: (e) => handleChange(isMultiple ? e.map((item) => item.value) : e.value), labelColor: labelColor, isMultiple: isMultiple, selectedLabelColor: selectedLabelColor, selectedOptionColor: selectedOptionColor, value: isMultiple ? selectedCountries : selectedCountry, touched: touched, isInvalid: isInvalid, hideAllOption: true }));
};
export default CountrySelect;
//# sourceMappingURL=CountrySelect.js.map